import {Fragment, useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import {Edit} from "./Edit";
import {put} from "../../js/api";
import {markDirty, showMessage} from "../../js/main";

export const UpdateDiscount = ({discounts, keys, handleApiError}) => {

    const {discountId} = useParams();
    const [selectedDiscount, setSelectedDiscount] = useState();
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        if (discounts) {
            setSelectedDiscount(discounts.find(e => e.id === parseInt(discountId)));
        }
    }, [discounts, discountId]);

    const handleSave = (discount) => {
        return put("/discounts/" + discount.id, discount, false)
            .then(() => {
                markDirty();
                showMessage("Gespeichert.");
            })
            .catch(handleApiError);
    };

    return (
        <Fragment>
            {selectedDiscount &&
             <Edit initialDiscountInfo={selectedDiscount}
                   keys={keys}
                   saveAction={handleSave}
                   submitting={submitting}
                   setSubmitting={setSubmitting}/>}
        </Fragment>
    );
};
